export const languages = [
  {
    name: 'English',
    code: 'en',
    img: '/assets/icons/flag/united-kingdom.svg',
  },
  {
    name: 'Español',
    code: 'es',
    img: '/assets/icons/flag/spain.svg',
  },
  {
    name: 'Arabic',
    code: 'ar',
    img: '/assets/icons/flag/arab.svg',
  },
  {
    name: 'Catalan',
    code: 'ct',
    img: '/assets/icons/flag/spain.svg',
  },
  {
    name: 'French',
    code: 'fr',
    img: '/assets/icons/flag/france.svg',
  },
  {
    name: 'Russian',
    code: 'ru',
    img: '/assets/icons/flag/russia.svg',
  },
  {
    name: 'Japanese',
    code: 'ja',
    img: '/assets/icons/flag/japan.svg',
  },
  {
    name: 'Montenegrin',
    code: 'cnr',
    img: '/assets/icons/flag/montenegrin.svg',
  },
  {
    name: 'German',
    code: 'de',
    img: '/assets/icons/flag/german.svg',
  },
  {
    name: 'Portuguese',
    code: 'pt',
    img: '/assets/icons/flag/portugal.svg',
  },
  {
    name: 'Korean',
    code: 'ko',
    img: '/assets/icons/flag/korea.svg',
  },
  {
    name: 'Chinese',
    code: 'zh',
    img: '/assets/icons/flag/china.svg',
  },];
